import { render } from "./i-email.vue?vue&type=template&id=6aeeee4b"
import script from "./i-email.vue?vue&type=script&lang=js"
export * from "./i-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__